<template>
	<div>
		<aeg-case-home
			:caseViews="caseViews"
			addProposalButtonText="Add Commercial Block Proposal"
			productTypeLabel="Type"
			selectProductInsuranceType="commercial_block"
		></aeg-case-home>
	</div>
</template>

<script>
import AegCaseHome from "./AegCaseHome"

export default {
	components: {
		AegCaseHome
	},
	data() {
		return {
			caseViews: {
				commercial_block: "AegCaseCommercialBlock"
			}
		}
	}
}
</script>
